import React from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { Language } from "../../redux/store/base/language";

interface ApplicationProps {
  title: string;
}

const SEO = (props: ApplicationProps) => {
  const state = useSelector((state: { lang: Language }) => state);
  const { id, dir } = state?.lang?.caruentLanguage;
  return (
    <Helmet htmlAttributes={{ lang: id, dir: dir }}>
      <meta charSet="utf-8" />
      <title>{props.title}</title>
      {/* <link rel="canonical" href="http://mysite.com/example" /> */}
    </Helmet>
  );
};

export default SEO;
